import { useState } from 'preact/hooks';

const API_URL = import.meta.env.VITE_API_URL || 'https://api.unplug-app.com';

export function SubscriptionExpired({ subscription, workspace }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function handleUpgrade() {
    setLoading(true);
    setError(null);

    try {
      const sessionId = localStorage.getItem('sessionId');
      const res = await fetch(`${API_URL}/v3/subscription/checkout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionId}`
        }
      });

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || 'Failed to create checkout session');
      }

      const data = await res.json();
      if (data.checkout_url) {
        window.location.href = data.checkout_url;
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div class="subscription-expired-page">
      <div class="expired-container">
        <div class="expired-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>

        <h1>Subscription Expired</h1>

        <p class="expired-message">
          {subscription?.status === 'trialing'
            ? 'Your free trial has ended.'
            : 'Your subscription has expired.'}
        </p>

        <p class="expired-details">
          Upgrade to continue using Unplug with {workspace?.name || 'your workspace'}.
        </p>

        {error && (
          <div class="error-message">
            {error}
          </div>
        )}

        <div class="expired-actions">
          <button
            class="btn btn-primary btn-lg"
            onClick={handleUpgrade}
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Upgrade Now'}
          </button>
        </div>

        <div class="expired-features">
          <h3>What you get with Pro:</h3>
          <ul>
            <li>Unlimited leave requests</li>
            <li>Team calendar and planner</li>
            <li>Malta employment law compliance</li>
            <li>Slack integration</li>
            <li>Email notifications</li>
            <li>Admin dashboard</li>
          </ul>
        </div>

        <p class="expired-contact">
          Questions? Contact us at{' '}
          <a href="mailto:support@maltashopper.com">support@maltashopper.com</a>
        </p>
      </div>

      <style>{`
        .subscription-expired-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          padding: 2rem;
        }

        .expired-container {
          background: white;
          border-radius: 12px;
          padding: 3rem;
          max-width: 480px;
          width: 100%;
          text-align: center;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
        }

        .expired-icon {
          width: 80px;
          height: 80px;
          margin: 0 auto 1.5rem;
          color: #f59e0b;
        }

        .expired-icon svg {
          width: 100%;
          height: 100%;
        }

        .subscription-expired-page h1 {
          font-size: 1.75rem;
          color: #1e293b;
          margin-bottom: 1rem;
        }

        .expired-message {
          font-size: 1.125rem;
          color: #64748b;
          margin-bottom: 0.5rem;
        }

        .expired-details {
          color: #94a3b8;
          margin-bottom: 2rem;
        }

        .error-message {
          background: #fef2f2;
          color: #dc2626;
          padding: 0.75rem 1rem;
          border-radius: 8px;
          margin-bottom: 1.5rem;
        }

        .expired-actions {
          margin-bottom: 2rem;
        }

        .btn-lg {
          padding: 1rem 2rem;
          font-size: 1.125rem;
        }

        .expired-features {
          text-align: left;
          background: #f8fafc;
          padding: 1.5rem;
          border-radius: 8px;
          margin-bottom: 1.5rem;
        }

        .expired-features h3 {
          font-size: 1rem;
          color: #475569;
          margin-bottom: 0.75rem;
        }

        .expired-features ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .expired-features li {
          padding: 0.5rem 0;
          color: #64748b;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .expired-features li::before {
          content: "\\2713";
          color: #22c55e;
          font-weight: bold;
        }

        .expired-contact {
          color: #94a3b8;
          font-size: 0.875rem;
        }

        .expired-contact a {
          color: #3b82f6;
        }
      `}</style>
    </div>
  );
}
